import Constants from '@/Constants';
import { LinkMetadata } from '@/models/LinkMetadata';
import { useGet } from './useGet';

const getKey = (path?: string) => {
    if (!path || path === '') {
        return null;
    }

    const [protocol, url] = path.split('://');

    return `${Constants.TRACKING_METADATA_URI}?protocol=${protocol}&url=${url}`;
};

export const useMetadata = (path?: string) => {
    const { data: metadata } = useGet<LinkMetadata>(getKey(path));

    return { metadata };
};
